module.exports = __webpack_public_path__ + "static/media/4.24.12f16893.png";